import React, { useState } from "react";

const API = process.env.REACT_APP_API_URL || "";

async function setNewPassword(newPassword) {
  const res = await fetch(`${API}/api/me/password`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ newPassword }),
  });

  if (res.status === 401) {
    throw new Error("Vous devez être connecté pour définir un mot de passe.");
  }

  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.message || "Erreur lors de la mise à jour du mot de passe");
  }
  return data;
}

/**
 * ChangePasswordPage — formulaire affiché juste après une connexion avec un
 * mot de passe "jeton" (créé par un administrateur) : l'utilisateur doit
 * définir son propre mot de passe avant de pouvoir utiliser le reste de
 * l'application. Voir LoginPage (redirection après /api/login) et
 * SessionInfo (redirection si mustChangePassword est déjà vrai via /api/me).
 */
export default function ChangePasswordPage() {
  const [newPassword, setNewPasswordValue] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (newPassword.length < 8) {
      setError("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Les deux mots de passe ne correspondent pas.");
      return;
    }

    setLoading(true);
    try {
      await setNewPassword(newPassword);
      window.location.href = "/";
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-page" style={{ maxWidth: 400, margin: "60px auto" }}>
      <h2 style={{ marginBottom: 8 }}>Nouveau mot de passe</h2>
      <p style={{ color: "#6b7280", marginBottom: 24 }}>
        Votre mot de passe actuel est un mot de passe temporaire. Choisissez
        votre propre mot de passe pour continuer.
      </p>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Nouveau mot de passe</label>
          <input
            type="password"
            className="form-control"
            value={newPassword}
            onChange={(e) => setNewPasswordValue(e.target.value)}
            autoComplete="new-password"
            minLength={8}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Confirmer le mot de passe</label>
          <input
            type="password"
            className="form-control"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
            minLength={8}
            required
          />
        </div>

        {error && (
          <div style={{ marginBottom: 16, padding: "8px 14px", borderRadius: 6, background: "#fee2e2", color: "#991b1b" }}>
            {error}
          </div>
        )}

        <button type="submit" className="fr-btn" disabled={loading} style={{ width: "100%" }}>
          {loading ? "Enregistrement..." : "Valider"}
        </button>
      </form>
    </div>
  );
}
